import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-788f9d2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "socials"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-fill" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "meta"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "text" }

import { modalController } from '@ionic/vue'
import { useRoute } from 'vue-router'
import { computed, ref } from 'vue'
import { useStoryblok } from '@storyblok/vue'
import { useMeta } from 'vue-meta'

import Artist from '@/models/Artist'
import Like from '@/components/global/Like.vue'
import Modal from '@/components/Modal.vue'
import { useStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'ArtistDetail',
  props: {
    data: null
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props as {
  data?: Artist
};


const route = useRoute()
const { id } = route.params
const story = id
  ? (
  ([__temp,__restore] = _withAsyncContext(() => useStoryblok(`artists/${id}`, {
      version: process.env.NODE_ENV === 'production' ? 'published' : 'draft',
    }))),
  __temp = await __temp,
  __restore(),
  __temp
)
  : ref(null)

const source = computed<Artist>(() => props.data ?? new Artist(story.value!))
const store = useStore()

const computedMeta = computed(() => ({
  title: source.value?.title ? `${source.value?.title} | Artist` : '',
  meta: [
    { property: 'og:url', content: window.location.href },
    {
      vmid: 'og:description',
      property: 'og:description',
      content: source.value.perex.replace(/(<([^>]+)>)/gi, '') || '',
    },
    {
      vmid: 'description',
      property: 'description',
      content: source.value.perex.replace(/(<([^>]+)>)/gi, '') || '',
    },
  ],
  link: [{ rel: 'canonical', href: window.location.href }],
}))

useMeta(computedMeta)

const close = () => {
  return modalController.dismiss()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "modal",
    image: _unref(source).picture,
    title: _unref(source).title,
    onClose: close
  }, {
    default: _withCtx(() => [
      (_unref(source).socials.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(source).socials, (item, i) => {
              return (_openBlock(), _createElementBlock("a", {
                key: i,
                fill: "clear",
                href: item.link
              }, _toDisplayString(item.icon), 9, _hoisted_2))
            }), 128)),
            _hoisted_3,
            _createVNode(Like, {
              class: "like",
              uuid: _unref(source).uuid,
              type: "artist"
            }, null, 8, ["uuid"])
          ]))
        : _createCommentVNode("", true),
      (_unref(store).config.schedule)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_unref(source).stage?.title) + " ", 1),
            _hoisted_5,
            _createTextVNode("— " + _toDisplayString(_unref(source).day) + " ", 1),
            _hoisted_6,
            _createTextVNode("— " + _toDisplayString(_unref(source).timeFormatted), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", null, _toDisplayString(_unref(source).perex), 1)
      ])
    ]),
    _: 1
  }, 8, ["image", "title"]))
}
}

})